import React from "react";
import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useClipboard, useToast, Text, Flex } from "@chakra-ui/react";
import { FaWhatsapp, FaCopy } from "react-icons/fa";

const ShareSuccessModal = ({ isOpen, onClose, shareLink }) => {
    const { onCopy } = useClipboard(shareLink);
    const toast = useToast();

    const handleCopyLink = () => {
        onCopy();
        toast({
            title: "Poveznica je kopirana!",
            description: "Pristupiti zadatku moguće je sa kopiranom poveznicom.",
            status: "success",
            duration: 2000,
            isClosable: true,
        });
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Uspjeh</ModalHeader>
                <ModalBody>
                    <Text>Zadatak je uspješno podijeljen!</Text>
                </ModalBody>
                <ModalFooter>
                    <Flex justifyContent="center" w="100%">
                        <Button
                            leftIcon={<FaWhatsapp color="white" />}
                            bg="green.500" 
                            color="white" 
                            flex="1"
                            mr={2}
                            _hover={{ bg: "green.600" }} 
                            _active={{ bg: "green.700" }} 
                            onClick={() => window.open(`https://wa.me/?text=Check out this ticket: ${shareLink}`, "_blank")}
                        >
                            WhatsApp
                        </Button>
                        <Button
                            leftIcon={<FaCopy />}
                            colorScheme="blue"
                            flex="1"
                            onClick={handleCopyLink}
                        >
                            Kopiraj poveznicu
                        </Button>
                    </Flex>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default ShareSuccessModal;